import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListNutritionistsResponseElement } from '../types/apiGeneratedTypes';

export interface NutritionistsPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddNutritionistModalOpened: boolean;
  nutritionistsList: ListNutritionistsResponseElement[] | null;
  limit: number;
  nutritionistDataToEdit: ListNutritionistsResponseElement | null;
  nutritionistsCount: number | null;
  sortKey: string | null;
  sortOrder: 'asc' | 'desc';
}

export const initialState: NutritionistsPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddNutritionistModalOpened: false,
  nutritionistsList: null,
  limit: 10,
  nutritionistDataToEdit: null,
  nutritionistsCount: null,
  sortKey: null,
  sortOrder: 'asc',
};

  const nutritionistsPageSlice = createSlice({
  name: 'nutritionists',
  initialState,
  reducers: {
    setNutritionistsPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearNutritionistsPageSearchValue(state) {
      state.searchValue = '';
    },
    addFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = [...state.appliedFilters, action.payload];
    },
    deleteFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = state.appliedFilters.filter(
        (el) => el !== action.payload
      );
    },
    clearAllFilters(state) {
      state.appliedFilters = [];
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddNutritionistModalOpened = action.payload;
    },
    setNutritionistDataToEdit(
      state,
      action: PayloadAction<ListNutritionistsResponseElement | null>
    ) {
      state.nutritionistDataToEdit = action.payload;
    },
    setNutritionistsList(state, action: PayloadAction<ListNutritionistsResponseElement[]>) {
      state.nutritionistsList = action.payload;
    },
    setNutritionistsCount(state, action: PayloadAction<number>) {
      state.nutritionistsCount = action.payload;
    },
    appendNutritionistsList(
      state,
      action: PayloadAction<ListNutritionistsResponseElement[]>
    ) {
      if (!state.nutritionistsList) {
        state.nutritionistsList = action.payload;
      } else {
        state.nutritionistsList = [...state.nutritionistsList, ...action.payload];
      }
    },
    setSorting(
      state,
      action: PayloadAction<{ key: string; order: 'asc' | 'desc' }>
    ) {
      state.sortKey = action.payload.key;
      state.sortOrder = action.payload.order;
    },
  },
});

export const {
  setNutritionistsPageSearchValue,
  clearNutritionistsPageSearchValue,
  addFilter,
  deleteFilter,
  clearAllFilters,
  changeModalVisibility,
  setNutritionistsList,
  appendNutritionistsList,
  setNutritionistDataToEdit,
  setNutritionistsCount,
  setSorting,
} = nutritionistsPageSlice.actions;
export default nutritionistsPageSlice.reducer;
